import { useOrganizationBaseDetailsQuery } from "@modules/organization/queries.generated"
import { MachinePricingTier } from "@modules/graphql/types"

export function useRollbacksAndManualDeploysAvailable(organizationId: string) {
  const { data, loading, error } = useOrganizationBaseDetailsQuery({
    variables: { id: organizationId },
  })

  const baseFeaturesTier =
    data?.organizationDetails?.billing?.plan?.baseFeatures?.tier
  const hostingTier = data?.organizationDetails?.billing?.plan?.hostingTier

  const isEligiblePlan =
    (baseFeaturesTier &&
      [
        MachinePricingTier.Professional,
        MachinePricingTier.Agency,
        MachinePricingTier.Enterprise,
      ].includes(baseFeaturesTier)) ||
    false

  const isEligibleLegacyPlan =
    (hostingTier &&
      [MachinePricingTier.Performance, MachinePricingTier.Enterprise].includes(
        hostingTier
      )) ||
    false

  return {
    result: isEligiblePlan || isEligibleLegacyPlan,
    loading,
    error,
  } as const
}
